import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="header-area sticky-header">
      {/* Top Bar - Hidden on mobile via d-none d-lg-block */}
      <div className="header-top-bar d-none d-lg-block">
        <div className="container-fluid custom-container">
          <div className="top-bar-content">
            {/* Contact section */}
            <div className="top-right-section">
              <div className="top-contact-info">
                <a
                  className="contact-link"
                  href="tel:7926442095"
                  title="Call us"
                >
                  <i className="fas fa-phone-alt"></i>
                  <span>7926442095 / 96</span>
                </a>

                <a
                  className="contact-link"
                  href="mailto:sales@sachiproducts.com"
                  title="Email us"
                >
                  <i className="fas fa-envelope"></i>
                  <span>sales@sachiproducts.com</span>
                </a>
              </div>
            </div>

            {/* Social icons */}
            <div className="top-social-icons">
              {/* Use <a> tags for external websites */}
              <a
                href="https://www.facebook.com/sachiproducts1996"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f"></i>
              </a>

              <a
                href="https://www.instagram.com/sachiproducts1996/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>

              <a
                href="https://www.youtube.com/@SACHIPRODUCTS"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Nav Area */}
      <div className="main-header-nav">
        <div className="container-fluid custom-container">
          <div className="header-align">
            <div className="header-logo">
              <Link to="/">
                <img src="/assets/img/sachi_logo.png" alt="Sachi Products" />
              </Link>
            </div>

            {/* THE FIX: This nav must have the "open" class based on state */}
            <nav className={`nav-menus-wrapper ${isMenuOpen ? "open" : ""}`}>
              {/* Close Button inside the mobile sidebar */}
              <div
                className="mobile-menu-close d-lg-none"
                onClick={toggleMenu}
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "20px",
                  fontSize: "24px",
                  cursor: "pointer",
                }}
              >
                <i className="fas fa-times"></i>
              </div>

              <ul className="main-menu">
                <li>
                  <NavLink to="/" end onClick={() => setIsMenuOpen(false)}>
                    HOME
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/about" onClick={() => setIsMenuOpen(false)}>
                    ABOUT
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/product" onClick={() => setIsMenuOpen(false)}>
                    PRODUCT CATEGORIES
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/inquiry" onClick={() => setIsMenuOpen(false)}>
                    INQUIRY
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/contact_us"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    CONTACT
                  </NavLink>
                </li>
              </ul>
            </nav>

            <div className="header-actions">
              {/* Hamburger Toggle */}
              <div className="mobile-toggle d-lg-none" onClick={toggleMenu}>
                <i className="fas fa-bars"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Dark Overlay - Critical for mobile UX */}
      <div
        className={`menu-overlay ${isMenuOpen ? "active" : ""}`}
        onClick={toggleMenu}
      ></div>
    </header>
  );
};

export default Header;
